/**
 * PlaybookNarration — the autopilot lower-third (spec §18). Shows the current act
 * + progress while a playbook runs, with a Stop control. Sits above the timeline.
 */
import { Film, Square } from 'lucide-react';
import { useFusionStore } from '../../stores/useFusionStore';
import { stopPlaybook } from '../../case-canvas/playbookRunner';

export function PlaybookNarration() {
  const pb = useFusionStore((s) => s.pb);
  if (!pb) return null;

  return (
    <div className="absolute left-1/2 -translate-x-1/2 bottom-24 z-20 w-[26rem] max-w-[90%] rounded-xl border border-border bg-card/95 backdrop-blur shadow-2xl px-4 py-3">
      <div className="flex items-center gap-2 mb-1">
        <Film size={14} className="text-primary" />
        <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
          Autopilot · Act {pb.actIndex} / {pb.totalActs}{pb.running ? '' : ' · done'}
        </span>
        {pb.running && (
          <button onClick={stopPlaybook} className="ml-auto flex items-center gap-1 text-[10px] text-muted-foreground hover:text-foreground px-1.5 py-0.5 rounded border border-border">
            <Square size={10} /> Stop
          </button>
        )}
      </div>
      <div className="text-sm font-semibold leading-snug">{pb.title}</div>
      <div className="text-[11px] text-muted-foreground mt-0.5 leading-snug">{pb.sub}</div>
      <div className="mt-2 flex gap-1">
        {Array.from({ length: pb.totalActs }, (_, i) => (
          <div key={i} className={`h-1 flex-1 rounded-full ${i < pb.actIndex ? 'bg-primary' : 'bg-muted'}`} />
        ))}
      </div>
    </div>
  );
}
